const STORAGE_KEY = 'machadalo.intervene.messageSoundsEnabled';

export function readMessageSoundsEnabled() {
  if (typeof window === 'undefined') return true;

  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored == null) return true;
    return stored === 'true';
  } catch {
    return true;
  }
}

export function writeMessageSoundsEnabled(enabled) {
  if (typeof window === 'undefined') return;

  try {
    window.localStorage.setItem(STORAGE_KEY, enabled ? 'true' : 'false');
  } catch {
    // Ignore quota / privacy mode errors.
  }
}
